<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <circle cx="9" cy="9" r="6.429" fill="var(--background-color, #FFF)" />
    <path
      fill="currentColor"
      d="M9 18c2.387 0 4.676-.948 6.364-2.636C17.05 13.676 18 11.387 18 9s-.948-4.676-2.636-6.364C13.676.95 11.387 0 9 0S4.324.948 2.636 2.636C.95 4.324 0 6.613 0 9s.948 4.676 2.636 6.364C4.324 17.05 6.613 18 9 18zM7.875 5.344c0-.621.504-1.125 1.125-1.125s1.125.504 1.125 1.125V9.28c0 .621-.504 1.125-1.125 1.125s-1.125-.504-1.125-1.125V5.344zM9 11.53c.455 0 .865.274 1.04.695.174.42.077.904-.245 1.226-.321.321-.805.418-1.226.244-.42-.175-.694-.585-.694-1.04 0-.62.504-1.125 1.125-1.125z"
    />
  </svg>
</template>
